import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {Resource} from '../../../graphql/resources.datatypes';
import {gqlResource} from '../getResource.api';

export interface UpdateOptionValuesVars {
    id: number,
}

interface UpdateOptionValuesData {
    __typename?: string,
    updateResourceOptionCosts: Resource
}

export const UPDATE_OPTION_VALUES_MUTATION = gql`
    mutation updateResourceOptionCosts($id: Int!) {
        updateResourceOptionCosts(id: $id) {
            ${gqlResource}
        }
    }
`;

export const updateResourceOptionCosts = () => useMutation<UpdateOptionValuesData, UpdateOptionValuesVars>(
    UPDATE_OPTION_VALUES_MUTATION,
    {
        update: updateCacheByType('Resource'),
    }
);

export default updateResourceOptionCosts;